<template>
  <div>
    <vs-card>
      <div>
        <CurrentAccountFilter
          @filter="setFilters"
          @export="exportReport"
        ></CurrentAccountFilter>
      </div>
      <div>
        <template lang="html">
          <div class="listRelatorioConsolidado lg:block">
            <vs-table
              noDataText="Não há dados para exibir!"
              stripe
              :data="data"
            >
              <div
                slot="header"
                class="flex flex-wrap-reverse items-center flex-grow justify-end"
              >
                <div class="flex">
                  <!------------ START ITENS POR PÁGINA ------------>
                  <vs-dropdown
                    vs-trigger-click
                    class="cursor-pointer mb-4 mr-4"
                  >
                    <div
                      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                    >
                      <span class="mr-2"
                        >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                        {{
                          count - currentPage * itemsPerPage > 0
                            ? currentPage * itemsPerPage
                            : count
                        }}
                        de {{ count }}</span
                      >
                      <feather-icon
                        icon="ChevronDownIcon"
                        svgClasses="h-4 w-4"
                      />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="itemsPerPage = 5">
                        <span>5</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 25">
                        <span>25</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 50">
                        <span>50</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
              <template slot="thead">
                <vs-th width="20%" sort-key="broker">Corretora</vs-th>
                <vs-th width="10%" sort-key="susep">Nº Susep</vs-th>
                <vs-th width="20%" sort-key="consultancy"> Assessoria</vs-th>
                <vs-th width="10%" sort-key="period">Período</vs-th>
                <vs-th width="14%" sort-key="received_value"
                  >Valor recebido (R$)</vs-th
                >
                <vs-th width="14%" sort-key="used_value">
                  Valor usado (R$)
                </vs-th>
                <vs-th width="13%" sort-key="final_value">
                  Saldo final (R$)
                </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td width="20%">
                    {{ tr.broker_name }}
                  </vs-td>

                  <vs-td width="10%">
                    {{ tr.susep_number }}
                  </vs-td>

                  <vs-td width="20%">
                    {{ tr.consultancy_name }}
                  </vs-td>

                  <vs-td width="10%">
                    {{ tr.period }}
                  </vs-td>

                  <vs-td width="12%" class="text-right pr-4">
                    {{ formatMoney(tr.received_amount.toFixed(2)) }}
                  </vs-td>

                  <vs-td width="12%" class="text-right pr-4">
                    {{ formatMoney(tr.spent_amount.toFixed(2)) }}
                  </vs-td>

                  <vs-td width="16%" class="text-right pr-4">
                    {{
                      formatMoney(
                        (tr.received_amount - tr.spent_amount).toFixed(2),
                      )
                    }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="mt-6" v-if="data.length">
              <vs-pagination
                :total="Math.ceil(count / itemsPerPage)"
                v-model="currentPage"
              ></vs-pagination>
            </div>
          </div>
        </template>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { fi } from 'vuejs-datepicker/src/locale';
import reportsApi from '../../../../services/reports.api';
import functions from '../../../../utils/functions';

export default {
  name: 'CurrentAccountUse',
  components: {
    CurrentAccountFilter: () =>
      import('../../../filtros/CurrentAccountFilter.vue'),
  },
  data() {
    return {
      data: [],
      itemsPerPage: 50,
      currentPage: 1,
      count: 0,
      filters: null,
    };
  },
  methods: {
    setFilters(filters) {
      this.filters = filters;
      this.getData();
    },
    async getData() {
      reportsApi
        .getCurrentAccountUsageReport({
          ...this.filters,
          pageSize: this.itemsPerPage,
        })
        .then((response) => {
          this.data = response.items;
          this.count = response.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async exportReport(filters) {
      try {
        this.$vs.loading();
        const buffer = await reportsApi.exportCurrentAccountUsageReport(
          filters,
          true,
        );
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `current-account-usage-report-${now}.xlsx`;
        await functions.downloadFromBuffer(window, buffer, fileName);
      } catch (error) {
        console.error('Erro ao fazer download do arquivo', error);
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Erro ao fazer download do arquivo.`,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    formatMoney(number) {
      if (isNaN(number)) {
        number = 0;
      }
      const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      return formatter.format(number);
    },
  },
  watch: {
    currentPage() {
      this.filters.page = this.currentPage;
      this.getData();
    },
    itemsPerPage() {
      this.filters.pageSize = this.itemsPerPage;
      this.getData();
    },
  },
};
</script>

<style></style>
